import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../services/reports.service';
import { finalize } from 'rxjs/operators';
import { UtilsService } from '../services/utils.service';

@Component({
  selector: 'app-players-by-venue-report',
  templateUrl: './players-by-venue-report.component.html',
  styleUrls: ['./players-by-venue-report.component.css']
})
export class PlayersByVenueReportComponent implements OnInit {

  venue: string = ''
  venueId: string = ''
  date_from: string = ''
  date_to: string = ''
  fetching: Boolean = false
  players: PlayersByVenue = null

  constructor(private reportService: ReportsService, private utilService: UtilsService) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.fetching = false
    }, 300);
  }

  getPlayers() {

    const f = new Date(this.date_from)
    const t = new Date(this.date_to)

    if (f > t || !this.date_from || !this.date_to) return

    this.fetching = true
    this.reportService.getPlayersByVenue(this.venueId, this.date_from, this.date_to)
      .pipe(finalize(() => this.fetching = false))
      .subscribe((result: PlayersByVenue) => {
        this.players = result

      }, error => {
        console.log("An error occured:" + error);
        console.log(error);

      })

  }

  onTypeaheadSelected(result) {
    if (result.hasOwnProperty('name')) {
      this.venue = result['name']
    }
    if (result.hasOwnProperty('sid')) {
      this.venueId = result['sid']
    }

  }

  onTypeaheadCleared(itemType: string) {
    this.venue = ''
  }

  exportTableToCSV(tableId) {
    const filename = `Players by Venue - ${this.venue} (${this.date_from} to ${this.date_to}).csv`;
    let csv = this.utilService.extractTableData(tableId);
    this.utilService.downloadAsCSV(csv.join('\n'), filename);
  }

}
